import React, { useCallback, useEffect, useState } from "react";
import { InfoTip } from "@/components/InfoTip";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Admin: site-wide free-trial switch + today's usage against the daily ceiling.
export function AdminFreeTrial() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/free-trial");
      setSt(data);
    } catch {
      setSt(null);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/free-trial", { enabled: !st.enabled });
      setSt(data);
      toast.success(data.enabled ? "Essais gratuits rallumés." : "Essais gratuits coupés.");
    } catch {
      toast.error("Échec de la mise à jour.");
    } finally {
      setBusy(false);
    }
  };

  if (!st) return null;
  return (
    <div className="border border-[#002FA7] p-6 max-w-3xl mt-6" data-testid="admin-free-trial-panel">
      <div className="sux-marker mb-2 flex items-center gap-2"><Gift className="w-3 h-3" /> Essais gratuits<InfoTip testid="admin-free-trial-info" content={"Les essais sans compte coûtent de l'IA. Le plafond du jour limite la perte à environ 1 € par jour. Coupez-les si vous voulez zéro dépense non payée."} /></div>
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[220px] text-sm">
          <div data-testid="admin-free-trial-status">
            Statut : <b className={st.enabled ? "text-[#0a7a2f]" : "text-[#FF2A00]"}>{st.enabled ? "Allumés" : "Coupés"}</b>
          </div>
          <div className="font-mono text-xs text-muted-foreground mt-1" data-testid="admin-free-trial-usage">
            Aujourd&apos;hui : {st.used} / {st.cap} essais · perte maximale ≈ 1 € par jour
          </div>
        </div>
        <button
          type="button"
          onClick={toggle}
          disabled={busy}
          data-testid="admin-free-trial-toggle-btn"
          className={`font-mono uppercase tracking-[0.2em] text-[11px] px-6 py-3 text-white transition-colors disabled:opacity-50 flex items-center gap-2 ${st.enabled ? "bg-[#FF2A00] hover:bg-[#cc2200]" : "bg-[#002FA7] hover:bg-[#00227A]"}`}
        >
          {busy && <Loader2 className="w-3 h-3 animate-spin" />} {st.enabled ? "Couper les essais" : "Rallumer les essais"}
        </button>
      </div>
      <p className="mt-3 text-xs text-muted-foreground font-mono">
        Les visiteurs sans crédits voient « Résumer votre texte : dès 2 € les 20 résumés » quand c&apos;est coupé ou que le plafond est atteint. Les acheteurs ne sont pas concernés.
      </p>
    </div>
  );
}

export default AdminFreeTrial;
